export { default } from './SecondaryText';
